<template>
  <el-dialog :title="staff ? '重置员工密码：' + staff.name : '修改密码'" :visible="visible" width="min(480px,94vw)" append-to-body :close-on-click-modal="false" @close="$emit('update:visible', false)" @open="clear">
    <el-form label-width="100px" @submit.native.prevent="save">
      <el-form-item v-if="!staff" label="当前密码"><el-input v-model="form.old_password" type="password" show-password autocomplete="current-password" /></el-form-item>
      <el-form-item label="新密码"><el-input v-model="form.new_password" type="password" show-password autocomplete="new-password" placeholder="至少8个字符，最多72字节" /></el-form-item>
      <el-form-item label="确认新密码"><el-input v-model="confirm" type="password" show-password autocomplete="new-password" @keyup.enter.native="save" /></el-form-item>
    </el-form>
    <div slot="footer"><el-button @click="$emit('update:visible',false)">取消</el-button><el-button type="primary" :loading="saving" @click="save">{{ staff ? '重置密码' : '修改密码' }}</el-button></div>
  </el-dialog>
</template>
<script>
import http from '../api/http';
export default {
  props: { visible: Boolean, staff: { type:Object, default:null } },
  data:()=>({form:{old_password:'',new_password:''},confirm:'',saving:false}),
  methods: {
    clear() { this.form={old_password:'',new_password:''};this.confirm=''; },
    async save() {
      if(this.saving) return;
      if(!this.staff && !this.form.old_password) { this.$message.warning('请填写当前密码');return; }
      if(this.form.new_password.length<8 || new Blob([this.form.new_password]).size>72) { this.$message.warning('密码至少8个字符，最多72字节');return; }
      if(this.form.new_password!==this.confirm) { this.$message.warning('两次输入的新密码不一致');return; }
      this.saving=true;
      try {
        await http.put(this.staff?`/staff/${this.staff.id}/password`:'/auth/password', this.staff?{new_password:this.form.new_password}:this.form);
        this.$message.success(this.staff?'员工密码已重置，旧登录已失效':'密码已修改，请重新登录');
        this.$emit('update:visible',false);this.clear();this.$emit('completed');
      } finally { this.saving=false; }
    }
  }
};
</script>
